<template>
  <div class="flex flex-row">
    <input
      :type="type"
      :class="inputStyle"
      :min="min"
      :max="max"
      :id="inputId"
      v-model.number="localValue"
      :placeholder="measurementIndicator.placeholder"
      :aria-label="ariaLabel"
      :disabled="disabled"
      :style="
        disabled
          ? { 'cursor': 'not-allowed', 'border': 'none', 'background-color': 'var(--color-callout-bg, #F3F1EC)' }
          : {}
      "
      @blur="$emit('blur')"
    />
    <div class="px-4 measurement-indicator">{{ measurementIndicator.label }}</div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { MeasurementIndicator } from "../../../types";

export default Vue.extend({
  props: {
    value: { type: Number, required: true },
    type: { type: String, default: "number" },
    min: { type: Number, default: 0 },
    max: { type: Number, required: true },
    ariaLabel: { type: String, required: true },
    inputStyle: { type: String, required: true },
    measurementIndicator: { type: Object as PropType<MeasurementIndicator>, required: true },
    inputId: { type: String, required: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
});
</script>
